import { render, staticRenderFns } from "./FormAccordion.vue?vue&type=template&id=d604b8a0&"
import script from "./FormAccordion.vue?vue&type=script&lang=js&"
export * from "./FormAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\DigitalCreditTransfer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d604b8a0')) {
      api.createRecord('d604b8a0', component.options)
    } else {
      api.reload('d604b8a0', component.options)
    }
    module.hot.accept("./FormAccordion.vue?vue&type=template&id=d604b8a0&", function () {
      api.rerender('d604b8a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/FormAccordion.vue"
export default component.exports